// 用户管理接口请求

import fetch from '../fetch';

import {
  POINT_GRANT_DAILY,
  POINT_CONSUME_DAILY,
  POINT_DAILY,
  DEPART_MENT_DAILY,
  GET_TASK_HEAD,
  GET_TASK_DETAIL,
  GET_TASK_PIE_CHART,
  GET_TASK_TABLE
} from '../url';

// 获取积分发放日报
function getPointGrantDaily(data) {
  return fetch({
    url: POINT_GRANT_DAILY,
    method: 'post',
    data: data,
    isNoMsg: true
  });
};

// 获取积分消耗日报
function getPointConsumeDaily(data) {
  return fetch({
    url: POINT_CONSUME_DAILY,
    method: 'post',
    data: data,
    isNoMsg: true
  });
};

// 获取积分日报
function getPointDaily(data) {
  return fetch({
    url: POINT_DAILY,
    method: 'post',
    data: data,
    isNoMsg: true
  });
};

// 事业部对账日报
function departmentDaily(data) {
  return fetch({
    url: DEPART_MENT_DAILY,
    method: 'post',
    data: data,
    isNoMsg: true
  });
};

/**
 * 任务看板数据概况
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getTaskHead(data) {
  return fetch({
    url: GET_TASK_HEAD,
    method: 'post',
    data: data
  });
};

/**
 * 任务看板折线图
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getTaskDetail(data) {
  return fetch({
    url: GET_TASK_DETAIL,
    method: 'post',
    data: data
  });
};

/**
 * 任务看板-饼图
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getTaskPieChart(data) {
  return fetch({
    url: GET_TASK_PIE_CHART,
    method: 'post',
    data: data
  });
};

/**
 * 任务看板表格数据
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getTaskTable(data) {
  return fetch({
    url: GET_TASK_TABLE,
    method: 'post',
    data: data
  });
};

const otherReports = {
  getPointGrantDaily,
  getPointConsumeDaily,
  getPointDaily,
  departmentDaily,
  getTaskHead,
  getTaskDetail,
  getTaskPieChart,
  getTaskTable
};

export { otherReports };
